import { createContext } from "react";

const ProductCtxt = createContext(null);

export default ProductCtxt;
